<template>
  <div class="mt-48 bg-white bg-opacity-60 min-h-screen">
    <div class="flex items-center justify-start bg-beige-academy-300 w-full py-5
      text-white text-left">
      <div class="text-lg w-full px-5 lg:px-20 font-sans-serif font-bold flex">
        <router-link class="pr-1" to="/teacher-dashboard/classrooms">
          {{$t('classrooms.classrooms')}}
        </router-link> /
        <router-link class="px-1" to="/teacher-dashboard/templates">
          {{$t('template.templates')}}
        </router-link>
      </div>
    </div>
    <div class="flex w-full justify-center items-center mt-10 px-3 lg:px-64
    text-black" v-if="template">
      <h1 class="text-lg lg:text-2xl text-center w-full uppercase">{{ template.description }}</h1>
    </div>

    <div class="flex justify-between w-full lg:w-3/4 mx-auto py-10 items-start text-center">
      <media-list :media="availableMedia" class="mr-2 lg:mr-10"
      :buttons="true" :title="$t('media.available')"
        @selected="moveMediaToSelected($event)" />
      <media-list :media="selectedMedia" class="ml-2 lg:ml-10"
      :buttons="true" :title="$t('media.selected')"
        @selected="moveMediaToAvailable($event)" />
    </div>

    <modal resizable name="media-uploader" height="auto" :adaptive="true">
      <media-uploader class="w-full"
        :id="user.teacher.id" @media-uploaded="getMedia" />
    </modal>

  </div>
</template>

<script>
import axios from 'axios';
import { getTeacherTemplate, getTeacherMedia } from '@/services/TeacherService';
import { mapGetters } from 'vuex';
import MediaList from '@/components/teachers/MediaList.vue';
import MediaUploader from '@/components/fileUpload/MediaUploader.vue';

export default {
  data() {
    return {
      template: null,

      availableMedia: [],
      selectedMedia: [],
    };
  },

  components: {
    MediaList,
    MediaUploader,
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getTemplate();
  },

  methods: {
    getTemplate() {
      getTeacherTemplate(this.user.teacher.id, this.$route.params.id).then(({ data }) => {
        this.template = data;
        this.selectedMedia = this.template.media;
        this.getMedia();
      });
    },

    getMedia() {
      getTeacherMedia(this.user.teacher.id).then(({ data }) => {
        this.availableMedia = [];
        data.forEach((media) => {
          if (!this.selectedMedia.find((m) => m.id === media.id)) {
            this.availableMedia.push(media);
          }
        });
      });
    },

    moveMediaToSelected(media) {
      axios.post(`/api/classroom-templates/${this.$route.params.id}/attach/${media.id}`).then(() => {
        const index = this.availableMedia.indexOf(media);
        this.availableMedia.splice(index, 1);
        this.selectedMedia.push(media);
      });
    },

    moveMediaToAvailable(media) {
      axios.post(`/api/classroom-templates/${this.$route.params.id}/detach/${media.id}`).then(() => {
        const index = this.selectedMedia.indexOf(media);
        this.selectedMedia.splice(index, 1);
        this.availableMedia.push(media);
      });
    },
  },
};
</script>
